import clsx from 'clsx'
import { NavLink, useLocation } from 'react-router-dom'
import { ReactComponent as ExpertSvg } from '../../../../assets/svgs/expert.svg'
import { Option } from './Option'
import { Button } from '../../../../components/Button'
import { ProjectForm } from './ProjectForm'
import { useEffect, useMemo, useRef, useState } from 'react'
import { handlerType } from '../../../../enumns/handlerType'
import { type ProjectDomain } from '../../../../types/domain/project-domain'
import { useInfiniteScroll } from '../../../../hooks/useInfiniteScroll'
import { Spinner } from '../../../../components/Spinner'
import { type RequestDomain } from '../../../../types/domain/request-domain'

type Props = {
  data: ProjectDomain[] | undefined
  isLoadingProjects: boolean
  hasMoreProjects?: boolean
  isLoadingMoreProjects?: boolean
  onLoadMoreProjects: () => void
  requestId?: number
  requestData?: RequestDomain
}

export const Sidebar = ({
  data,
  isLoadingProjects,
  hasMoreProjects = false,
  isLoadingMoreProjects = true,
  onLoadMoreProjects,
  requestId,
  requestData,
}: Props) => {
  const [modalCreateProject, setModalCreateProject] = useState<boolean>(false)
  const [openedOnce, setOpenedOnce] = useState<boolean>(false)
  const projectsContainerRef = useRef<HTMLDivElement>(null)
  const location = useLocation()

  const closeModalHandler = () => {
    window.history.replaceState(null, location.pathname)
    setOpenedOnce(true)
    setModalCreateProject(false)
  }

  useInfiniteScroll(projectsContainerRef, hasMoreProjects, onLoadMoreProjects)

  useEffect(() => {
    if (requestId) {
      if (requestId && requestData) {
        setModalCreateProject(true)
      }
    }
  }, [requestId, requestData])

  const formatedRequestData = useMemo(() => {
    if (requestData && !openedOnce) {
      return {
        name: requestData.projectName,
        clientId: requestData.client?.id,
        requesterId: requestData.requester?.id,
        description: requestData.description,
        assetIds: requestData?.asset
          ? [{ id: requestData.asset?.id }].map((value) => ({
              id: value.id,
            }))
          : [{ id: undefined }],
        analystIds: requestData?.analyst
          ? [{ id: requestData.analyst?.id }].map((value) => ({
              id: value.id,
            }))
          : [{ id: undefined }],
      }
    } else {
      return undefined
    }
  }, [requestData, requestId, openedOnce])

  return (
    <>
      {/* Sidebar */}
      <aside className="lg:sticky lg:top-8">
        <nav className="flex flex-col">
          <div className="mb-5">
            <Button
              type="button"
              size="small"
              onClick={() => setModalCreateProject(true)}
              className="py-[14px] h-auto"
              fullWidth
            >
              <p className="text-base font-medium text-white ">Novo projeto</p>
            </Button>
          </div>

          <div
            ref={projectsContainerRef}
            className="w-full pr-2 overflow-y-auto max-h-80 scrollbar"
          >
            {isLoadingProjects ? (
              <div className="flex items-center justify-center h-20">
                <Spinner />
              </div>
            ) : (
              <>
                {data?.map((project) => (
                  <Option
                    title={project.name}
                    id={project.id}
                    key={project.id}
                  />
                ))}

                {isLoadingMoreProjects && (
                  <div className="flex justify-center py-2">
                    <Spinner size="small" />
                  </div>
                )}
              </>
            )}
          </div>

          <div className="h-[2px] w-full bg-grey-200 my-3" />

          <NavLink
            to="archived"
            className={({ isActive }) =>
              clsx('w-full  font-medium h-14 flex px-4 rounded-2xl', {
                'bg-secondary-dark text-white font-bold  stroke-white':
                  isActive,
                'text-[#777777] font-medium stroke-[#777777]': !isActive,
              })
            }
          >
            <span className="flex items-center gap-4">
              <ExpertSvg />
              Projetos Arquivados
            </span>
          </NavLink>
        </nav>
      </aside>

      {/* Project Form Modal */}
      <ProjectForm
        isOpen={modalCreateProject}
        title="Novo Projeto"
        onClose={closeModalHandler}
        type={handlerType.SAVE}
        requestData={formatedRequestData}
        requestId={requestId}
      />
    </>
  )
}
